import { combineReducers } from "redux";
// import reducer from "./reducer";
import gridReducer from "./reducer/gridReducer";
import cardViewReducer from "./reducer/cardViewReducer";


const rootReducer = combineReducers({
    gridReducer,
    cardViewReducer
})

export default rootReducer;
